import { createContext, useContext, useMemo, type ReactNode } from "react";
import { useQuery } from "@tanstack/react-query";
import { parseShowcaseMediaMap } from "@nexra/contracts";
import { api } from "../api";
import { catalogQueryPolicy } from "../query-policy";
import { resolveShowcaseMedia, type ResolvedShowcaseMedia } from "../lib/showcase-media";

const ShowcaseMediaContext = createContext<ResolvedShowcaseMedia>(resolveShowcaseMedia({}));

export function ShowcaseMediaProvider({ children }: { children: ReactNode }) {
  const query = useQuery({
    ...catalogQueryPolicy,
    queryKey: ["showcase-media"],
    queryFn: async ({ signal }) => {
      const response = await api<{ data: unknown }>("v1/showcase-media", { signal });
      return parseShowcaseMediaMap(response.data);
    },
    staleTime: 30_000,
    retry: false,
  });
  // Query retains the last successful mapping during refresh failures; missing slots use published TOS defaults.
  const media = useMemo(() => resolveShowcaseMedia(query.data ?? {}), [query.data]);
  return <ShowcaseMediaContext value={media}>{children}</ShowcaseMediaContext>;
}

export function useShowcaseMedia() { return useContext(ShowcaseMediaContext); }
